import { create } from 'zustand';

export interface DeferredApplicationCounts {
  pendingUpgrade: number;
  readyToProcess: number;
  /** PIPELINE_ERROR + billing_limit_reached — retry, not first-time screening */
  billingRetry: number;
}

interface PendingBillingState extends DeferredApplicationCounts {
  setDeferredCounts: (counts: DeferredApplicationCounts) => void;
  patchDeferredCounts: (patch: Partial<DeferredApplicationCounts>) => void;
}

export const usePendingBillingStore = create<PendingBillingState>((set) => ({
  pendingUpgrade: 0,
  readyToProcess: 0,
  billingRetry: 0,
  setDeferredCounts: (counts) => set(counts),
  patchDeferredCounts: (patch) => set((prev) => ({ ...prev, ...patch })),
}));

/** Banner shows only candidates not yet in the pipeline. */
export function bannerDeferredCount(counts: DeferredApplicationCounts): number {
  return counts.pendingUpgrade + counts.readyToProcess;
}

/** Rows the recruiter can start/retry from the post-upgrade banner. */
export function processableCount(counts: DeferredApplicationCounts): number {
  return counts.readyToProcess + counts.billingRetry;
}

/** Green banner title — all deferred CVs (awaiting upgrade + ready). */
export function displayReadyCount(
  counts: DeferredApplicationCounts,
  hasProcessingCredits: boolean,
): number {
  if (hasProcessingCredits) {
    return counts.readyToProcess + counts.billingRetry;
  }
  return counts.pendingUpgrade + counts.readyToProcess + counts.billingRetry;
}
